<div>
  <mat-toolbar class="app-header">
    <div class="app-header-content">
      <a [routerLink]="['/projects']"><img src="assets/images/acticon_icon_logo.svg" /></a>
    </div>
    <ng-content select="app-breadcrumbs"></ng-content>
    <span class="cf-flex-1"></span>
    <div class="cf-flex-row cf-align-items-center">
      <div *ngIf="user$ | async as user">
        <button data-test="HeaderMenu" mat-button class="email-button" disableRipple="true" [matMenuTriggerFor]="menu">
          <mat-icon svgIcon="person"></mat-icon>
          <span>{{ user?.Email }}</span>
        </button>
      </div>
      <mat-menu #menu="matMenu" xPosition="before">
        <a data-test="UserSettings" mat-menu-item routerLink="/projects/user-settings">
          {{ 'User.UserSettings' | translate }}
        </a>
        <a mat-menu-item routerLink="/projects/change-password">
          {{ 'User.ChangePassword' | translate }}
        </a>
        <a [href]="baseUrl + '/Admin'" target="_blank" mat-menu-item>{{ 'UI.Common.Action.GoToAdminApp' | translate }}</a>
        <button data-test="Logout" mat-menu-item (click)="onLogout()">{{ 'User.Logout' | translate }}</button>
      </mat-menu>

      <mat-button-toggle-group
        class="custom-group language-selection"
        name="language"
        aria-label="Select language"
        (change)="onLanguageChange($event.value)"
        [hideSingleSelectionIndicator]="true"
      >
        <mat-button-toggle data-test="SEButton" [checked]="(selectedLanguage$ | async) === 'sv-SE'" disableRipple="true" value="sv-SE"
          >SE</mat-button-toggle
        >
        <mat-button-toggle data-test="ENButton" [checked]="(selectedLanguage$ | async) === 'en'" disableRipple="true" value="en"
          >EN</mat-button-toggle
        >
        <mat-button-toggle data-test="NOButton" [checked]="(selectedLanguage$ | async) === 'nn-NO'" disableRipple="true" value="nn-NO"
          >NO</mat-button-toggle
        >
      </mat-button-toggle-group>
    </div>
  </mat-toolbar>
</div>
